<template>
  <div class="header-wrapper">
    <div class="page-header">
      <div
        class="nav-title"
        @mouseover="showTag()"
        @mouseout="hideTag()"
      >
        <router-link
          :to="homeSite"
        ><img src="../../../assets/img/logo@2x.png">
          <div
            v-show="historyHeader && isShowTag"
            class="little-tag"
          >
            <img src="../../../assets/img/回主页图标.png">
            <img src="../../../assets/img/回主页.png">
          </div>
        </router-link>
      </div>

      <menu-nav
        v-show="historyHeader"
        :menu-list="menuList"
      />

      <div class="nav-user">
        <el-dropdown>
          <span class="el-dropdown-link">
            <img
              src="../../../assets/img/1.png"
              data-toggle="dropdown"
            >
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><a href="#/userInformation">个人中心</a></el-dropdown-item>
            <el-dropdown-item><a
              href="javascript:;"
              @click="logout"
            >安全退出</a></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { globalService } from '@/service/globalService'
import { mapActions } from 'vuex'

import {menuList} from './menuListData'
import menuNav from './menuList'

export default {
  name: 'CirdHeader',
  components: {menuNav},
  props: {
    historyHeader: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      menuList: menuList,
      isShowTag: false,
      homeSite: '/main'
    }
  },
  mounted () {
    this.checkModuleAuth()
  },
  methods: {
    ...mapActions({
      logout: 'logout'
    }),
    // 验证各模块权限
    checkModuleAuth () {
      let authDic = globalService.getUserAuthDic()
      this.menuList.forEach(i => {
        i.isLogin = authDic[i.Id]
      })
    },
    // 显示tag
    showTag () {
      this.isShowTag = true
    },
    hideTag () {
      this.isShowTag = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/common/header/header.vue